import React from "react";
import { TessaMessageRendererProps } from "@/features/tessa/types";
import { AiChatPart } from "@gettactic/api";
import { ChatBotToolCard } from "@/features/tessa/components/ChatBotToolCard";
import { useAskTessa } from "@cmp-src/tessa/AskTessaProvider";
import { cn } from "@gettactic/helpers";

export const getToolCallComponent = (m: string) => {
  const toolCallComponent: React.FC<TessaMessageRendererProps<AiChatPart>> = ({
    part
  }) => {
    const askTessa = useAskTessa();
    const isCompact = askTessa?.fullPageToolDisclosure?.isOpen;
    const isPopup = !!askTessa?.isPopup;

    return (
      <ChatBotToolCard
        className={cn(
          "rounded-xl bg-white/80",
          !isCompact && !isPopup && "max-w-[60%]"
        )}
        isZoomEnabled={false}
      >
        <div
          className={
            "tessa-tool hyphens-auto break-words text-[14px] text-neutral-500"
          }
        >
          {m}
          {!part.output ? (
            <span className="loading-ellipsis">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          ) : null}
        </div>
      </ChatBotToolCard>
    );
  };

  return toolCallComponent;
};
